import { render, staticRenderFns } from "./AddTrainingAreaDialog.vue?vue&type=template&id=1089d06f"
import script from "./AddTrainingAreaDialog.vue?vue&type=script&lang=js"
export * from "./AddTrainingAreaDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports